import { render } from "./PdfGeneralData.vue?vue&type=template&id=df720faa&scoped=true&ts=true"
import script from "./PdfGeneralData.vue?vue&type=script&lang=ts"
export * from "./PdfGeneralData.vue?vue&type=script&lang=ts"

import "./PdfGeneralData.vue?vue&type=style&index=0&id=df720faa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df720faa"]])

export default __exports__